module.exports = __webpack_public_path__ + "16129fb520dce2d303144ffebff4fc35.svg";